export default __webpack_public_path__ + "static/media/nammadoors2.0a6d2040.png";